export function normalizePhoneNumber(value?: string): string {
  if (!value) return "";
  if (value[0] === "+") return value.slice(1);
  return value;
}
